module.exports = __webpack_public_path__ + "static/img/jctj001.65e0408.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jctj001.png
// module id = nImr
// module chunks = 3